module.exports = __webpack_public_path__ + "img/down_arrow_icon.e9095010.svg";